module.exports = __webpack_public_path__ + "img/idx.8f6c8a31.svg";